import { useQuery } from '@tanstack/react-query'

import { getProductAvailabilityById } from '@flecto/api/saas'
import { type GetProductAvailabilityByIdOptions } from '@flecto/api/store'
import { type ParameterID } from '@flecto/types'

type GetProductAvailabilityByIdProps = {
  productId?: ParameterID
  options: GetProductAvailabilityByIdOptions
}

export function useQueryGetProductAvailabilityById({ productId, options }: GetProductAvailabilityByIdProps) {
  return useQuery({
    queryKey: ['QueryGetProductAvailabilityById', options],
    queryFn: async () =>
      await getProductAvailabilityById(productId ?? '', options),
  })
}
